import { render, staticRenderFns } from "./TransferTravellers.vue?vue&type=template&id=68c967dc&scoped=true"
import script from "./TransferTravellers.vue?vue&type=script&lang=js"
export * from "./TransferTravellers.vue?vue&type=script&lang=js"
import style0 from "./TransferTravellers.vue?vue&type=style&index=0&id=68c967dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c967dc",
  null
  
)

export default component.exports